module.exports = __webpack_public_path__ + "img/Group 1137.05e06bec.svg";